import React, { Fragment, useState } from "react";
import { NavLink } from "react-router-dom";
import Logo from "../../assets/logo.jpeg";
import { PUBLIC, NON_AUTHENTICATED } from "../../config/AppNavigations";

import {
  MdMenu,
  MdNotifications,
  MdAccountCircle,
  MdClose,
  MdApps,
  MdVerifiedUser,
  MdSupervisedUserCircle,
  MdCallToAction,
  MdTimeline,
} from "react-icons/md";
import { ImFilePicture } from "react-icons/im";
import { AiFillGift, AiOutlineMessage } from "react-icons/ai";
import UserMenu from "./UserMenu";
import { Auth } from "../../actions";
import { RiVideoFill } from "react-icons/ri";
import { AiOutlineTeam } from "react-icons/ai";
import { FaPray } from "react-icons/fa";
import { IoNewspaperOutline } from "react-icons/io5";

interface NavigationProps {
  isAuthenticated: boolean;
  Logout: Function;
  email: string | undefined;
  NavToogle: Function;
  navActive: boolean;
  auth: Auth;
}

const Navigation = ({
  isAuthenticated,
  email,
  Logout,
  NavToogle,
  navActive,
  auth,
}: NavigationProps) => {
  const [accountModal, setaccountModal] = useState(false);

  let SideNavLinks = (
    <Fragment>
      {auth.user?.user_type_id === 1 && (
        <NavLink
          exact
          to="/events"
          key="News"
          className={`flex flex-row items-center gap-2 justify-start py-3 rounded-md- px-3 hover:bg-green-500 hover:text-white text-center  border-b- border-gray-200 `}
        >
          <MdVerifiedUser className="text-2xl m-0" />
          <span className="text-base">Events</span>
        </NavLink>
      )}
      {auth.user?.user_type_id === 1 && (
        <NavLink
          exact
          to="/news"
          key="News"
          className={`flex flex-row items-center gap-2 justify-start py-3 rounded-md- px-3 hover:bg-green-500 hover:text-white text-center  border-b- border-gray-200 `}
        >
          <IoNewspaperOutline className="text-2xl m-0" />
          <span className="text-base">News</span>
        </NavLink>
      )}
      {auth.user?.user_type_id === 1 && (
        <NavLink
          exact
          to="/members"
          key="Users"
          className={`flex flex-row items-center gap-2 justify-start py-3 rounded-md- px-3 hover:bg-green-500 hover:text-white text-center  border-b- border-gray-200 `}
        >
          <MdSupervisedUserCircle className="text-2xl m-0" />
          <span className="text-base">Users</span>
        </NavLink>
      )}
      {auth.user?.user_type_id === 1 && (
        <NavLink
          exact
          to="/volunteers"
          key="Volunteers"
          className={`flex flex-row items-center gap-2 justify-start py-3 rounded-md- px-3 hover:bg-green-500 hover:text-white text-center  border-b- border-gray-200 `}
        >
          <MdSupervisedUserCircle className="text-2xl m-0" />
          <span className="text-base">Volunteers</span>
        </NavLink>
      )}
      {auth.user?.user_type_id === 1 && (
        <NavLink
          exact
          to="/gallery"
          key="Gallery"
          className={`flex flex-row items-center gap-2 justify-start py-3 rounded-md- px-3 hover:bg-green-500 hover:text-white text-center  border-b- border-gray-200 `}
        >
          <ImFilePicture className="text-2xl m-0" />
          <span className="text-base">Gallery</span>
        </NavLink>
      )}
      {auth.user?.user_type_id === 1 && (
        <NavLink
          exact
          to="/welcome-message"
          key="welcome-message"
          className={`flex flex-row items-center gap-2 justify-start py-3 rounded-md- px-3 hover:bg-green-500 hover:text-white text-center  border-b- border-gray-200 `}
        >
          <AiOutlineMessage className="text-2xl m-0" />
          <span className="text-base">Welcome Message</span>
        </NavLink>
      )}
      {auth.user?.user_type_id === 1 && (
        <NavLink
          exact
          to="/programmes"
          key="programmes"
          className={`flex flex-row items-center gap-2 justify-start py-3 rounded-md- px-3 hover:bg-green-500 hover:text-white text-center  border-b- border-gray-200 `}
        >
          <MdTimeline className="text-2xl m-0" />
          <span className="text-base">Programmes</span>
        </NavLink>
      )}
      {auth.user?.user_type_id === 1 && (
        <NavLink
          exact
          to="/gifts"
          key="gifts"
          className={`flex flex-row items-center gap-2 justify-start py-3 rounded-md- px-3 hover:bg-green-500 hover:text-white text-center  border-b- border-gray-200 `}
        >
          <AiFillGift className="text-2xl m-0" />
          <span className="text-base">Gifts</span>
        </NavLink>
      )}
      {auth.user?.user_type_id === 1 && (
        <NavLink
          exact
          to="/videos"
          key="videos"
          className={`flex flex-row items-center gap-2 justify-start py-3 rounded-md- px-3 hover:bg-green-500 hover:text-white text-center  border-b- border-gray-200 `}
        >
          <RiVideoFill className="text-2xl m-0" />
          <span className="text-base">Videos</span>
        </NavLink>
      )}
      {auth.user?.user_type_id === 1 && (
        <NavLink
          exact
          to="/team"
          key="team"
          className={`flex flex-row items-center gap-2 justify-start py-3 rounded-md- px-3 hover:bg-green-500 hover:text-white text-center  border-b- border-gray-200 `}
        >
          <AiOutlineTeam className="text-2xl m-0" />
          <span className="text-base">Team</span>
        </NavLink>
      )}
      {auth.user?.user_type_id === 1 && (
        <NavLink
          exact
          to="/prayers"
          key="prayers"
          className={`flex flex-row items-center gap-2 justify-start py-3 rounded-md- px-3 hover:bg-green-500 hover:text-white text-center  border-b- border-gray-200 `}
        >
          <FaPray className="text-2xl m-0" />
          <span className="text-base">Prayers</span>
        </NavLink>
      )}
      <NavLink
        exact
        to="/activities"
        key="Activities"
        className={`flex flex-row items-center gap-2 justify-start py-3 rounded-md- px-3 hover:bg-green-500 hover:text-white text-center  border-b- border-gray-200 `}
      >
        <MdCallToAction className="text-2xl m-0" />
        <span className="text-base">Activities</span>
      </NavLink>
    </Fragment>
  );

  return (
    <Fragment>
      <nav className="top-navigation bg-white fixed inset-x-0 top-0 z-50 border-b border-gray-300">
        <div
          className={`${
            isAuthenticated === true
              ? "mx-auto px-3"
              : "max-w-7xl sm:px-6 lg:px-24 mx-auto"
          }`}
        >
          <div className="relative flex items-center justify-between h-16">
            <div className="px-2 md:px-0 flex items-center justify-center sm:items-stretch sm:justify-start">
              <div className="flex items-center">
                {isAuthenticated === true && (
                  <button
                    className="mr-3 sm:block lg:hidden"
                    aria-controls="mobile-menu"
                    aria-expanded="false"
                    onClick={() => NavToogle()}
                  >
                    {navActive === true ? (
                      <MdClose className="text-3xl animate__animated animate__rotateIn animate__faster" />
                    ) : (
                      <MdMenu className="text-3xl animate__animated animate__rotateIn animate__faster" />
                    )}
                    <span className="sr-only">Open main menu</span>
                  </button>
                )}
                {/* Left items */}
                <span>
                  <img className="w-12" src={Logo} alt="" />
                </span>
                <span className="text-2xl ml-2 font-bold uppercase text-gray-500">
                  ADMIN
                </span>
              </div>
            </div>
            <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
              {/* Right side menus */}
              <div className="hidden sm:block sm:ml-6 mr-6">
                <div className="flex space-x-4 items-center justify-end text-gray-500 ">
                  {isAuthenticated === false && (
                    <Fragment>
                      {PUBLIC.map((link, i) => (
                        <NavLink
                          key={i}
                          exact
                          to={link.url}
                          className={`main-navigation`}
                        >
                          {link.title}
                        </NavLink>
                      ))}

                      {!isAuthenticated &&
                        NON_AUTHENTICATED.map((link, i) => (
                          <NavLink
                            key={i}
                            exact
                            to={link.url}
                            className={`main-navigation`}
                          >
                            {link.title}
                          </NavLink>
                        ))}
                    </Fragment>
                  )}
                </div>
              </div>

              {isAuthenticated === true && (
                <Fragment>
                  <NavLink to="#" className="ml-6 hidden sm:block">
                    <MdNotifications className="text-2xl text-gray-600" />
                  </NavLink>
                  {/* Profile dropdown */}
                  <div className="ml-6 relative">
                    <div>
                      <button
                        type="button"
                        className="flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                        id="user-menu-button"
                        aria-expanded="false"
                        aria-haspopup="true"
                        onClick={() => setaccountModal(!accountModal)}
                      >
                        <span className="sr-only">Open user menu</span>
                        <MdAccountCircle className="text-3xl text-gray-600" />
                      </button>
                    </div>
                    {/* Profile menus */}
                    {accountModal === true && (
                      <>
                        <div
                          className="fixed top-0 right-0 left-0 bottom-0"
                          onClick={() => setaccountModal(false)}
                        ></div>
                        {auth.user !== null && (
                          <UserMenu
                            user={auth.user}
                            Logout={Logout}
                            close={() => setaccountModal(false)}
                          />
                        )}
                      </>
                    )}
                  </div>
                </Fragment>
              )}
            </div>
          </div>
        </div>
        {/* Mobile menu, show/hide based on menu state. */}
      </nav>

      {isAuthenticated === true && (
        <div
          className={`side-nav-container fixed pl-0 text-gray-700 bg-white overflow-x-hidden overflow-y-auto w-52 ${
            navActive === true ? "lg:left-0  left-0" : " -left-72 lg:left-0"
          } top-0 bottom-0 pt-20 z-40 border-r border-gray-300  transition-all duration-200 ease-in-out`}
        >
          <NavLink
            exact
            to="/profile"
            key="Profile details"
            className={`side-nav-icons `}
          >
            <MdAccountCircle className="icon-item-nav" />
            <span className="text-base">Profile</span>
          </NavLink>

          {/* {FC_Access(auth, UserAccessList.MY_APPLICATION).view && ( */}
          <NavLink
            exact
            to="/admin"
            key="Dashboard"
            className={`side-nav-icons`}
          >
            <MdApps className="icon-item-nav" />
            <span className="text-base">Dashboard</span>
          </NavLink>
          {/* )} */}

          {SideNavLinks}
        </div>
      )}

      {navActive === true && (
        <div
          onClick={() => NavToogle()}
          className="z-10 bg-black sm:block lg:hidden bg-opacity-20 fixed top-0 right-0 left-0 bottom-0"
        ></div>
      )}
    </Fragment>
  );
};

export default Navigation;
